// Auth monitoring plugin for session state management
export default defineNuxtPlugin(() => {
  const { status, session } = useAuth()
  
  watch(status, (newStatus) => {
    // Auth status changed - update app state if needed
    if (newStatus === 'unauthenticated') {
      // Clear any user-specific state when logged out
      useState('selectedUser').value = null;
    }
  })
  
  watch(session, (newSession) => {
    // Session data updated - sync with app state
    if (newSession?.user?.id) {
      // Update selected user when session changes
      useState('selectedUser').value = newSession.user.id;
    }
  })
})